import { Api } from "../Api";

export const criaTermo = async (parametros) => {
  const { data } = await Api.post("/termo/criar", parametros);
  return data;
};
